import { render, staticRenderFns } from "./business-port-list.vue?vue&type=template&id=0562b541&scoped=true&"
import script from "./business-port-list.vue?vue&type=script&lang=js&"
export * from "./business-port-list.vue?vue&type=script&lang=js&"
import style0 from "./business-port-list.vue?vue&type=style&index=0&id=0562b541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562b541",
  null
  
)

export default component.exports